import { ThirdPartyScript, ThirdPartyScriptProps } from '@/components/content/ThirdPartyScript';
import { useSettings } from '@/data/Settings';
import { FC } from 'react';
import { GOOGLE_RECAPTCHA_URL } from 'shared/custom/constants/commonConstants';

export const Recaptcha: FC = () => {
	const { settings } = useSettings();
	const recaptchaScoreBasedKey = settings.userData.GOOGLE_RECAPTCHA_SCORE_BASED_SITE_KEY || '';
	const props: ThirdPartyScriptProps = {
		src: GOOGLE_RECAPTCHA_URL + recaptchaScoreBasedKey,
		id: 'googleRecaptcha',
		async: false,
	};

	return <ThirdPartyScript {...props} />;
};
